import Auth from './models/Auth'
import User from './models/User'
import Request from './models/Request'
import PaymentCard from './models/PaymentCard'
import Generic from './models/Generic'
import Contact from './models/Contact'
import Storage from './models/Storage'
import Inventory from './models/Inventory'
import Payment from './models/Payment'
import Catalog from './models/Catalog'
import Price from './models/Price'
import City from './models/City'
import Partner from './models/Partner'
import Coupon from './models/Coupon'
import Invoice from './models/Invoice'
import StripeInvoice from './models/StripeInvoice'
import PaymentsControl from './models/PaymentsControl'
import Citas from './models/Citas'
import Entrega from './models/Entrega'
import Expense from './models/Expense'
import Emulator from './models/Emulator'
import Landings from './models/Landings'
import Conekta from './models/Conekta'
import PayDebt from './models/PayDebt'
import StripePayments from './models/StripePayments'
import Contrato from './models/Contrato'
import CRMAction from './models/CRMAction'

class API {

    constructor(token){
        this.auth = new Auth(token);
        this.user = new User(token);
        this.request = new Request(token);
        this.paymentCard = new PaymentCard(token);
        this.generic = new Generic(token);
        this.contacto = new Contact(token);
        this.storage = new Storage(token);
        this.inventory = new Inventory(token);
        this.payment = new Payment(token);
        this.catalog = new Catalog(token);
        this.price = new Price(token);
        this.city = new City(token);
        this.partner = new Partner(token)
        this.coupon = new Coupon(token)
        this.invoice = new Invoice(token)
        this.stripeInvoice = new StripeInvoice(token)
        this.stripePayments = new StripePayments(token)
        this.paymentsControl = new PaymentsControl(token)
        this.citas = new Citas(token)
        this.entregas = new Entrega(token)
        this.expenses = new Expense(token)
        this.emulator = new Emulator(token)
        this.landings = new Landings(token);
        this.conekta = new Conekta(token)
        this.payDebt = new PayDebt(token);
        this.contracts = new Contrato(token);
        this.crm_action = new CRMAction(token)
    }

}


export default API



